import(/* webpackMode: "eager" */ "/home/runner/work/cat-app/cat-app/app/layout.tsx");
